export enum ScheduleFrequency {
  Daily = 'Daily',
  Weekly = 'Weekly',
  Monthly = 'Monthly',
  LastDayOfMonth = 'LastDayOfMonth',
  NoFrequency = 'NoFrequency',
  Quarterly="Quarterly",
  Semiannually="Semiannually",
}
